import { parse } from 'date-fns';

//eslint-disable-next-line @typescript-eslint/no-explicit-any
const identityPasswordValidation = (password: string, formData: Record<string, any> | null,
): boolean => {
  if (!password || password.length < 3) return false;

  const hasSequence = (str: string, length: number = 4): boolean => {
    const commonSequences = [
      'abcdefghijklmnopqrstuvwxyz',
      '0123456789',
      'qwertyuiop',
      'asdfghjkl',
      'zxcvbnm',
    ];

    const normalizedStr = str.toLowerCase();

    for (const seq of commonSequences) {
      for (let i = 0; i <= seq.length - length; i++) {
        const pattern = seq.substring(i, i + length);
        if (normalizedStr.includes(pattern)) return true;

        const reversePattern = pattern.split('').reverse().join('');
        if (normalizedStr.includes(reversePattern)) return true;
      }
    }

    return false;
  };

  const hasRepetition = (str: string, length: number = 4): boolean => {
    const normalizedStr = str.toLowerCase();

    for (let i = 0; i <= normalizedStr.length - length; i++) {
      const char = normalizedStr[i];
      let isRepetition = true;

      for (let j = 1; j < length; j++) {
        if (normalizedStr[i + j] !== char) {
          isRepetition = false;
          break;
        }
      }

      if (isRepetition) return true;
    }

    return false;
  };

  if (hasSequence(password) || hasRepetition(password)) {
    return false;
  }

  const lowercasePassword = password.toLowerCase();
  const personalInfoParts: string[] = [];

  const nameFields = ['firstName', 'middleName', 'lastName', 'secondLastName'];

  nameFields.forEach(field => {
    if (formData?.[field] && formData[field].length > 2) {
      personalInfoParts.push(formData[field].toLowerCase());

      if (formData[field].includes(' ')) {
        personalInfoParts.push(formData[field].toLowerCase().replace(/\s+/g, ''));
      }
    }
  });

  const nameParts: string[] = [];
  if (formData?.firstName) nameParts.push(formData.firstName);
  if (formData?.middleName) nameParts.push(formData.middleName);
  if (formData?.lastName) nameParts.push(formData.lastName);
  if (formData?.secondLastName) nameParts.push(formData.secondLastName);

  if (nameParts.length > 0) {
    personalInfoParts.push(nameParts.join(' ').toLowerCase());
    personalInfoParts.push(nameParts.join('').toLowerCase());
  }

  if (formData?.email && formData.email.includes('@')) {
    const emailParts = formData.email.split('@');
    const username = emailParts[0].toLowerCase();
    if (username.length > 2) {
      personalInfoParts.push(username);
    }

    const domain = `@${emailParts[1]}`.toLowerCase();
    personalInfoParts.push(domain);

    personalInfoParts.push(formData.email.toLowerCase());
  }

  if (formData?.dateOfBirth && formData.dateOfBirth.length > 5) {
    try {
      let birthDate;
      try {
        birthDate = parse(formData.dateOfBirth, 'dd/MM/yyyy', new Date());
      } catch (error) {
        try {
          birthDate = parse(formData.dateOfBirth, 'yyyy-MM-dd', new Date());
        } catch (error) {
          console.error('Could not parse date of birth');
        }
      }

      if (birthDate && !isNaN(birthDate.getTime())) {
        const day = birthDate.getDate().toString().padStart(2, '0');
        const month = (birthDate.getMonth() + 1).toString().padStart(2, '0');
        const year = birthDate.getFullYear().toString();

        const dateFormats = [
          `${day}/${month}/${year}`,
          `${day}${month}${year}`,
          `${day}.${month}.${year}`,
          `${day}-${month}-${year}`,
          `${year}.${month}.${day}`,
          `${year}${month}${day}`,
          `${year}/${month}/${day}`,
          `${year}-${month}-${day}`,
          `${month}-${day}-${year}`,
          `${month}${day}${year}`,
          `${month}.${day}.${year}`,
          `${month}/${day}/${year}`,
        ];

        dateFormats.forEach(dateFormat => {
          personalInfoParts.push(dateFormat.toLowerCase());
        });
      }
    } catch (error) {
      console.error('Error processing date of birth:', error);
    }
  }

  return !personalInfoParts.some(part => lowercasePassword.includes(part));
};

export default identityPasswordValidation;
